import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ActivityTracker extends Component {
    render() {
        return (this.props.children);
    }

    componentDidMount() {
        // listen to all click events
        window.addEventListener('click', this.handleClick, true);

        const { history } = this.props;

        // wait for the tealium script to load
        let intervalCount = 0;
        let scriptLoadInterval = setInterval(() => {
            if (window.utag || intervalCount >= 50) {
                clearInterval(scriptLoadInterval);

                // track a page view when app first loads
                this.handleLocationChange(history.location);
            }

            intervalCount++;
        }, 100);

        // listen for future changes
        history.listen(this.handleLocationChange);
    }

    handleLocationChange(location) {
        try {
            window.utag.view();
        } catch (e) {
            console.error('Analytics tracking failed');
            console.error(e);
        }
    }

    handleClick(e) {
        try {
            if (e.path && e.path.length) {
                const tagNamesToListen = ['button', 'a'];
                let path = e.path || e.composedPath();
                let sourceElement = path.find(element => {
                    if (element.tagName) {
                        let tagName = element.tagName.toLowerCase();

                        return tagNamesToListen.some(tn => tn === tagName);
                    }

                    return false;
                });

                // is this an element we care about?
                if (sourceElement) {
                    window.utag.link({
                        'event_type': 'click',
                        'event_name': sourceElement.innerText.replace(' ', '_').toUpperCase(),
                        'tealium_event': 'click'
                    });
                }
            }
        } catch (e) {
            console.error('Analytics tracking failed');
            console.error(e);
        }
    }
};

export default withRouter(ActivityTracker);